import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch partners
  export const fetchPartners = createAsyncThunk(
  'partners/fetchPartners',
  async (_, { rejectWithValue }) => {
    try {
        const token = localStorage.getItem('authToken');
        console.log(" the token  from slice------->", token)
        const response = await axios.get('https://onboard.rechargkit.biz/member/partners', {
        headers: {
        Authorization: `Bearer ${token}`,
          },
         });
      return response;
    } catch (error) {
      const message =
        error.response?.data?.msg || error.message || 'Failed to fetch partners';
      return rejectWithValue(message);
    }
  }
);

const partnersSlice = createSlice({
    name: 'partners',
    initialState: {
    partners: [],
    loading: false,
    error: null,
  },
  reducers: {
      resetPartners: (state) => {
      state.partners = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartners.fulfilled, (state, action) => {
        state.loading = false;
        state.partners = action.payload.data || [];
      })
      .addCase(fetchPartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPartners } = partnersSlice.actions;
export default partnersSlice.reducer;
